import { Component, OnInit, Input, Inject, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { IProxyActiveCheckIn } from 'src/app/models/user';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { FormBuilder } from '@angular/forms';
import { DetailsDialogComponent } from '../detailsdialog/detailsdialog.component';
import { GroupDetailsComponent } from '../group-details/group-details.component';

@Component({
  selector: 'app-addforcheckout',
  templateUrl: './addforcheckout.component.html',
  styleUrls: ['./addforcheckout.component.css']
})
export class AddforcheckoutComponent implements OnInit, OnChanges {


  // constructor(public dialogRef: MatDialogRef<AddforcheckoutComponent>,
  //   @Inject(MAT_DIALOG_DATA) public data: IProxyActiveCheckIn[], private fb: FormBuilder) { }
  @Input() ProxyData: IProxyActiveCheckIn[];

  @Input() fromCheckin: boolean;

  @Output() isValid = new EventEmitter<any>();
  constructor(private fb: FormBuilder, private dialog: MatDialog) { }

  FinalData: IProxyActiveCheckIn[];
  data: IProxyActiveCheckIn[];
  ngOnInit(): void {
    // console.log('Add ININT');
    if (this.ProxyData !== undefined) {
      this.data = this.ProxyData;
    }
  }
  onDone() {
    const total = this.data.filter(item => item.isSelected === true);
    // this.dialogRef.close({ data: this.data, total: total.length });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.data = this.ProxyData;
  }

  onSelectChange(id: number, value: boolean) {
    this.data = this.data.map(item => item.checkInId === id ? ({ ...item, isSelected: value }) : item);
    const total = this.data.filter(item => item.isSelected === true);
    this.isValid.emit({ data: this.data, total: total.length });
  }
  onSelectGroupChange(id: number, value: boolean) {
    this.data = this.data.map(item => item.groupId === id ? ({ ...item, isSelected: value }) : item);
    const total = this.data.filter(item => item.isSelected === true);
    this.isValid.emit({ data: this.data, total: total.length });
  }


  openDetailDialog(data: IProxyActiveCheckIn): void {
    const dialogRef = this.dialog.open(GroupDetailsComponent, {
      width: '600px',
      disableClose: true,
      panelClass: 'custom-dialog-container',
      data
    });


    dialogRef.afterClosed().subscribe(
      data1 => console.log('Dialog output:', data1)
    );
  }
}
